export const InvoiceStatusJson = [
  { id: 1, name: "Paid" },
  { id: 2, name: "Partially Paid" },
  { id: 3, name: "Pending" },
  { id: 4, name: "Invoiced" },
  { id: 5, name: "Withdrawn" },
];

export const currencyJson = [
  { id: 1, name: "INR" },
  { id: 2, name: "AUD" },
  { id: 3, name: "CAD" },
  { id: 4, name: "USD" },
  { id: 5, name: "NZD" },
  { id: 6, name: "EURO" },
  { id: 7, name: "GBP" },
  { id: 8, name: "AED" },
];
